import BaseComponent from '../abstracts/BaseComponent';

export default class ScrollDirectionComponent extends BaseComponent {
  get CLASSES() {
    return {
      up: 'scroll-up',
      down: 'scroll-down',
      active: 'active'
    };
  }

  get SELECTORS() {
    return {
      trigger: '.js-activate-on-scroll',
    };
  }

  constructor(element) {
    super(element);
    this.observeScroll();
  }

  observeScroll() {
    window.addEventListener('wheel', (e) => {

      const targetToActivate = document.querySelectorAll(this.SELECTORS.trigger);
      
      if (targetToActivate) {
        targetToActivate.forEach(target => {
          if(window.scrollY >= 30) {
            target.classList.add(this.CLASSES.active);
            document.documentElement.classList.add('scroll-active');
          } else {
            target.classList.remove(this.CLASSES.active);
            document.documentElement.classList.remove('scroll-active');
          }
        });

      }

      // PITTI20-90
      if (e.target.closest('.listing-grid-sidebar-right')) {
        return;
      }

      const scrollDir = e.deltaY > 0 ? 'down' : 'up';

      switch (scrollDir) {
        case 'up':
          this.$el.classList.remove(this.CLASSES.down);
          this.$el.classList.add(this.CLASSES.up);
          break;
        case 'down':
          this.$el.classList.remove(this.CLASSES.up);
          this.$el.classList.add(this.CLASSES.down);
          break;
        default:
          this.$el.classList.remove(this.CLASSES.up);
          this.$el.classList.remove(this.CLASSES.down);
      }
    });
  }
}
